import { render, staticRenderFns } from "./SignableDocumentsList.vue?vue&type=template&id=1974eb62&scoped=true&"
import script from "./SignableDocumentsList.vue?vue&type=script&lang=ts&"
export * from "./SignableDocumentsList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1974eb62",
  null
  
)

export default component.exports